import React from 'react';
import ReactDOM from 'react-dom/client';
// import { Amplify } from 'aws-amplify';
// import config from './amplifyconfiguration.json';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';

// Configure Amplify with your AWS exports
// Amplify.configure(config);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

